import { defaultFetcher } from "../HTTPClient";
import { JSONAPIDocument, serializers } from "../Serializer";
import { APIV3 } from "../HTTPClientV3";
import type { Review, ReviewPayload } from "./review";

const baseItems = "/items";

export function createReviewBySlug(slug: string, payload: ReviewPayload) {
  const url = `${baseItems}/${slug}/reviews`;
  const request = () =>
    APIV3.post<JSONAPIDocument<Review>>(url, {
      body: JSON.stringify(serializers.reviews.serialize(payload)),
    });

  return {
    json: async () => defaultFetcher(request, serializers.reviews),
    fallbackKey: url,
  };
}
